<template>
    <section>
        <div v-if="!loading && !error" class="cabinet-content-wrap">
            <HeaderPublic />

            <section class="cabinet__breadcrumbs">
                <router-link
                    to="/"
                    class="cabinet__breadcrumbs-link d-none d-md-flex"
                    >Главная</router-link
                >
                <span class="cabinet__breadcrumbs-arrow d-none d-md-flex"
                    >&rsaquo;</span
                >
                <router-link
                    to="/brands"
                    class="cabinet__breadcrumbs-link d-none d-md-flex"
                    >Бренды</router-link
                >
            </section>

            <div class="v2-retailer-brand__header">
                <div class="v2-retailer-brand__header-logo app-link">
                    <img
                        class="v2-retailer-brand__header-img ofi"
                        :src="brand.logo"
                        @click="activeTab = 1"
                    />
                </div>

                <div class="v2-retailer-brand__header-descr">
                    <h1
                        class="h1 cabinet-title cabinet-supplier-header__title v2-retailer-brand__header-title"
                    >
                        {{ brand.BrandName }}
                    </h1>
                </div>
            </div>

            <cabinet-tabs
                :tabs="tabs"
                :active="activeTab"
                :wrapper-classes="['v2-retailer-brand__nav']"
            >
                <div slot="0">
                    <section class="cabinet-supplier-detail">
                        <div class="cabinet-supplier-tab-content">
                            <brand-products ref="product-list" :brand="brand" />
                        </div>
                    </section>
                </div>
                <div slot="1">
                    <section class="cabinet-supplier-detail">
                        <div class="cabinet-supplier-tab-content">
                            <brand-about :brand="brand"></brand-about>
                        </div>
                    </section>
                </div>
            </cabinet-tabs>
        </div>
        <div v-if="!loading && error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="tryGetBrand"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import CabinetTabs from '@/components/Cabinet/Tabs'
import BrandAbout from '@/components/Public/Brand/About'
import BrandProducts from '@/components/Public/Brand/Products'
import HeaderPublic from '@/components/Public/PublicHeader'

export default {
    name: 'BrandsID',
    components: {
        CabinetTabs,
        BrandAbout,
        BrandProducts,
        HeaderPublic
    },
    data() {
        return {
            currentBrandID: this.$route.params.id,
            brand: {},
            activeTab: 0,
            error: false,
            loading: true,
            tabs: ['Изделия', 'О компании']
        }
    },
    async created() {
        await this.getBrand(this.currentBrandID)
    },
    beforeRouteEnter(to, from, next) {
        console.log(from)
        if (from.name !== 'ProductID' && from.name !== 'RetailerProductID') {
            localStorage.removeItem('retailer-catalog-data')
        }

        next()
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'ProductID' || to.name === 'RetailerProductID') {
            const { filter, search, view, pagination, sort } = this.$refs[
                'product-list'
            ].$children[0]
            const retailerCatalogData = {
                filter,
                search,
                view,
                pagination,
                sort
            }

            localStorage.setItem(
                'retailer-catalog-data',
                JSON.stringify(retailerCatalogData)
            )
        } else {
            localStorage.removeItem('retailer-catalog-data')
        }

        next()
    },
    methods: {
        getBrand(brandID) {
            this.error = false
            this.$Progress.start()
            this.loading = true
            this.$axios
                .get(`/public/dict/brands/${brandID}`)
                .then(response => {
                    this.error = false
                    this.brand = response.data
                    this.$Progress.finish()
                    this.loading = false

                    document.title = this.brand.BrandName
                })
                .catch(error => {
                    this.error = true
                    this.$Progress.finish()
                    this.loading = false
                })
        },
        async tryGetBrand() {
            await this.getBrand(this.currentBrandID)
        }
    }
}
</script>
